import AuthProvider from "@mudrex/auth/src/auth/auth";
import { NetworkProvider } from "../api/api";
import {
  ChannelConfigEnum,
  ChannelEnum,
  ErrorData,
  FactorsEnum,
  ScopeEnum,
  SuccessAuthResponseData,
  SuccessMfaResponseData
} from "../types";
import AccountType from "./accounts.types";

class Account {
  async createAccountChallenge(
    channel: ChannelEnum,
    factor: FactorsEnum,
    data: AccountType
  ): Promise<{
    success: boolean;
    exists?: boolean;
    challenge?: string;
    errors?: ErrorData[];
    expiry?: Record<string, string>;
  }> {
    const url = `/accounts/${channel}/${factor}`;
    try {
      const networkProvider = NetworkProvider.getInstance();
      const response = await networkProvider.post(url, data);
      if (response?.success) {
        return {
          success: true,
          exists: false,
          challenge: response?.data?.challenge?.id,
          expiry: {
            expires_at: response?.data?.challenge?.expires_at,
            next_available_at: response?.data?.challenge?.next_available_at
          }
        };
      } else {
        if (response?.errors[0].code === 1005) {
          return {
            success: false,
            exists: true,
            errors: response?.errors as ErrorData[]
          };
        } else {
          return { success: false, errors: response?.errors as ErrorData[] };
        }
      }
    } catch (e) {}
    return { success: false };
  }

  async verifyAccountChallenge(
    channel: ChannelEnum,
    factor: FactorsEnum,
    data: AccountType,
    mfaToken: string
  ): Promise<{
    success: boolean;
    data?: SuccessAuthResponseData;
    errors?: ErrorData[];
  }> {
    const url = `/accounts/${channel}/${factor}/verify`;
    try {
      const config = {
        headers: {
          "X-Mfa-Token": mfaToken
        }
      };
      const networkProvider = NetworkProvider.getInstance();
      const response = await networkProvider.put(url, data, config);
      if (response?.success) {
        return {
          success: true,
          data: response?.data as SuccessAuthResponseData
        };
      } else {
        return { success: false, errors: response?.errors as ErrorData[] };
      }
    } catch (e) {}
    return { success: false };
  }

  async mergeAccountChallenge(
    channel: ChannelEnum,
    mfaToken: string,
    scope: ScopeEnum,
    configData: { [key in ChannelConfigEnum]?: string },
    xAuth: string
  ): Promise<{
    success: boolean;
    data?: SuccessAuthResponseData;
    errors?: ErrorData[];
  }> {
    const mergeUrl = "/accounts/merge";
    try {
      const networkProvider = NetworkProvider.getInstance();
      const config = {
        headers: {
          "X-Mfa-Token": mfaToken,
          "X-Authentication": xAuth
        }
      };
      const mergeResponse = await networkProvider.post(
        mergeUrl,
        {
          config: {
            channel,
            value:
              scope === ScopeEnum.EmailMerge
                ? configData?.email
                : scope === ScopeEnum.PhoneMerge
                  ? configData?.phone
                  : ""
          }
        },
        config
      );
      if (mergeResponse?.success) {
        return {
          success: true,
          data: mergeResponse?.data as SuccessAuthResponseData
        };
      } else {
        return {
          success: false,
          errors: mergeResponse?.errors as ErrorData[]
        };
      }
    } catch (e) {}
    return { success: false };
  }
}

export default Account;
